import styled from "styled-components";

export const Containers = styled.div`
  margin-top: ${(props) => (props.top ? props.top : 1)}em !important;
  margin-left: 60px !important;
  display: flex !important;
  flex-direction: row !important;
  max-width: 100%;
`;
